/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Birth_YearInputs */

const en_ui_thresholds_birth_year = /** @type {(inputs: Ui_Thresholds_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Birth year`)
};

const de_ui_thresholds_birth_year = /** @type {(inputs: Ui_Thresholds_Birth_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geburtsjahr`)
};

/**
* | output |
* | --- |
* | "Birth year" |
*
* @param {Ui_Thresholds_Birth_YearInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_birth_year = /** @type {((inputs?: Ui_Thresholds_Birth_YearInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Birth_YearInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_birth_year(inputs)
	return de_ui_thresholds_birth_year(inputs)
});